import { IsiGridManager } from "./IsiGridManager";
import { IsiGridView } from "../../IsiWebGUI/IsiFW/Components/Grid/IsiGridView";
import { IsiPlGridManager } from "../PresentationLogic/IsiPlGridManager";
import { IIsiUIFlowResultGeneric } from "../Core/IIsiUIFlowResultGeneric";
import { IsiDtoPlGridManagerResult } from "../../Dtos/Isilog.IsiComponent.IsiDataTransferObject.IsiPlGridManager";

export class IsiGridManagerNewGrid extends IsiGridManager {

    private _pl: IsiPlGridManager; 

    private getPl(): IsiPlGridManager {
        if (!this._pl) {
            this._pl = new IsiPlGridManager();
        }
        return this._pl
    }
    /**
     * Annule toutes les requêtes de count
     */
    abortAllAjaxRequest() {
        if (this._pl) {
            this._pl.abortAllCurrentActions();
        }
    }
      /**
     * Lance l'appel aJax qui renverra le nombre d'enregistrement dans la grille.
     */
    async getCountNewGrid(contextId: string, clientCtrlValues: { [key: string]: string; }): Promise<IIsiUIFlowResultGeneric<IsiDtoPlGridManagerResult>> {
        return await this.getPl().getCount(contextId, clientCtrlValues);
    }

    /**
     * Met à jour le compteur de l'en-tête de la grille avec le nombre d'enregistrements et le nb de pages remontés par le serveur
     */
    setCountNewGrid(nbRecord: number, contextId: string, nbPages: number) {
        uiCore.componentManager.getComponent<IsiGridView>(this.getContext(contextId).gridViewId).setCount(nbRecord, nbPages);
    }

}
